import React from 'react'
import { useClipboard } from '@chakra-ui/react'
import { FaCheck, FaShield } from 'react-icons/fa6'

import { MessageActionsProps } from './message-actions'
import MenuItem from '~components/shared/menu/menu-item'
import { useUserContext } from '~config/user-context'

export default function AdminCopyIdAction({
    message,
}: Pick<MessageActionsProps, 'message'>) {
    const { isAdmin } = useUserContext()
    const { hasCopied, onCopy } = useClipboard(message.id)

    if (!isAdmin) return null

    return (
        <MenuItem icon={hasCopied ? FaCheck : FaShield} onClick={onCopy}>
            {hasCopied ? 'Copied!' : 'Copy Message ID'}
        </MenuItem>
    )
}
